import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import * as moment from 'moment-timezone';

// Models
import { Order } from 'src/app/models/order';

// Services
import { ListOrdersService } from 'src/app/services/header/list-orders/list-orders.service';
import { TrackingService } from 'src/app/services/tracking/tracking.service';
import { AmplitudeService } from 'src/app/services/amplitude.service';

@Component({
    selector: 'app-order-list',
    templateUrl: './order-list.component.html',
    styleUrls: ['./order-list.component.sass'],
    standalone: false
})
export class OrderListComponent implements OnInit {

  listOrders: Order[] = [];

  gettingListOrders: boolean = false;

  listSubcriptions: Subscription[] = [];

  showCard: boolean = false;

  constructor(
    private _listOrdersService: ListOrdersService,
    private _trackingService: TrackingService,
    private _amplitudeService: AmplitudeService                   ,
    private _router: Router
  ) { }

  ngOnInit(): void {
    this.listenerOpenCard();
  }

  ngOnDestroy(): void {
    this.listSubcriptions.forEach((sub: Subscription) => { if (sub) sub.unsubscribe(); });
  }

  openTrackingOrder(order: Order): void {
    // location.href = `/#/rastreo/pedido/${order.id}/empresa/${order.clientId}`;
    this._router.navigate([`/rastreo/pedido/${order.id}/empresa/${order.clientId}`]);
    setTimeout(() => this._trackingService.reloadTrackingEmmiter(true), 200);
    this._amplitudeService.emmiterLogEvent('OPEN_ORDER', {
      ORDER_ID: order.id,
      CLIENT_ID: order.clientId,
      CLIENT_NAME: order.clientName,
      TOTAL: order.total,
      DATE: order.date,
    });
    this.closeCard();
  }

  async getListOrders() {
    this.gettingListOrders = true;
    let response: any = await this._listOrdersService.getListOrders().toPromise()
    .catch((err: any) => {
      this.gettingListOrders = false;
      console.log(err);
    });
    this.gettingListOrders = false;
    if( response && response.data && response.data.pedidos ){
      this.listOrders = new Order().mapOrder(response.data.pedidos);
      this.listOrders.map(o => o.dateFormated = moment.unix(o.date).format("[Fue realizado el ] DD [ de ] MM [a las ] hh:mm a"));
    }
    this._amplitudeService.emmiterLogEvent('OPEN_ORDER_LIST', {
      ORDERS_LENGTH: this.listOrders.length,
    });
  }

  closeCard(): void {
    this._listOrdersService.emmiterOpenCardListOrders(false);
    this._amplitudeService.emmiterLogEvent('CLOSE_ORDER_LIST', {
      ORDERS_LENGTH: this.listOrders.length,
    });
  }

  listenerOpenCard(): void {
    this.listSubcriptions.push(
      this._listOrdersService.getSubjetOpenCardListOrders().asObservable().subscribe(
        data => {
          this.showCard = data;
          if(data) this.getListOrders();
        }
      )
    );
  }

  // number_orders
  // number_shopping_car

}
